export default "__VITE_PUBLIC_ASSET__2fa4d847__"